import APIOfferQuestions from "@/api/modules/offer-questions";

const state = () => ({
  questionsList: [],
  questionsTotal: 0,
  question: null,
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
  },
  actions: {
    getQuestions({ commit }, params) {
      return APIOfferQuestions.getQuestions(params).then((response) => {
        if (response && response.data) {
          const list = response.data.questions || response.data || [];
          commit("SET_DATA", { type: "questionsList", data: Array.isArray(list) ? list : [] });
          // Yii2 exposes the total in the X-Pagination-Total-Count header.
          const total = parseInt(
            (response.headers && response.headers["x-pagination-total-count"]) || "",
            10
          );
          commit("SET_DATA", {
            type: "questionsTotal",
            data: Number.isNaN(total) ? (Array.isArray(list) ? list.length : 0) : total,
          });
        }
      });
    },
    getQuestion({ commit }, id) {
      return APIOfferQuestions.getQuestion(id).then((response) => {
        const q = (response && response.data && (response.data.question || response.data)) || null;
        commit("SET_DATA", { type: "question", data: q });
        return q;
      });
    },
    createQuestion(_, data) {
      return APIOfferQuestions.createQuestion(data);
    },
    updateQuestion(_, { id, data }) {
      return APIOfferQuestions.updateQuestion(id, data);
    },
    deleteQuestion(_, id) {
      return APIOfferQuestions.deleteQuestion(id);
    },
  },
};
